import { DatePipe, SlicePipe } from '@angular/common';
import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';
import {
  CardAccent,
  CardBodyComponent,
  CardComponent,
  CardHeaderComponent,
  CardLeadingComponent,
  CardTitleComponent,
  CardTrailingComponent,
  IconComponent,
} from '@softline/ui-core';
import { TimeReport } from '../../models/time-report';

@Component({
  selector: 'soft-report-card',
  imports: [
    DatePipe,
    SlicePipe,
    IconComponent,
    CardComponent,
    CardHeaderComponent,
    CardLeadingComponent,
    CardTitleComponent,
    CardTrailingComponent,
    CardBodyComponent,
  ],
  templateUrl: './report-card.component.html',
  styleUrl: './report-card.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportCardComponent {
  readonly report = input.required<TimeReport>();
  readonly navigable = input(false, { transform: booleanAttribute });

  readonly isRunning = computed(() => !this.report().to);

  readonly accentVar = computed(
    () => `var(--ds-card-accent-${this.presentation().accent})`
  );

  readonly presentation = computed<{
    accent: CardAccent;
    icon: string;
    iconClass: string;
  }>(() => {
    if (this.report().orderId == null) {
      return {
        accent: 'warning',
        icon: 'fa-regular fa-clock',
        iconClass: 'bg-surface-secondary text-light',
      };
    }
    return {
      accent: 'success',
      icon: 'fa-regular fa-screwdriver-wrench',
      iconClass: 'bg-surface-secondary text-light',
    };
  });

  readonly remove = output<TimeReport>();

  readonly openOrder = output<number>();

  readonly isInteractive = computed(
    () => this.navigable() && this.report().orderId != null
  );

  readonly activate = (): void => {
    const orderId = this.report().orderId;
    if (this.navigable() && orderId != null) this.openOrder.emit(orderId);
  };
}
